var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSupplyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#8FB16A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9029 45.201C65.8233 45.0352 65.6992 44.8954 65.5447 44.7976C65.3902 44.6997 65.2116 44.6479 65.0294 44.648H54.9159L62.9948 27.4012C63.065 27.2517 63.0966 27.0866 63.0866 26.9213C63.0767 26.7561 63.0256 26.5961 62.938 26.4562C62.8504 26.3164 62.7293 26.2012 62.5858 26.1214C62.4424 26.0416 62.2813 25.9999 62.1176 26H46.5883C46.4011 26 46.2178 26.0547 46.0607 26.1576C45.9035 26.2605 45.7792 26.4071 45.7025 26.5799L33.085 55.0425C33.0187 55.192 32.9905 55.3559 33.0028 55.5192C33.0152 55.6825 33.0679 55.8401 33.1559 55.9776C33.244 56.1151 33.3647 56.2282 33.507 56.3064C33.6493 56.3847 33.8087 56.4256 33.9707 56.4256H43.4428L38.8459 77.809C38.799 78.026 38.8263 78.2526 38.9232 78.4519C39.0202 78.6512 39.1812 78.8113 39.3798 78.9061C39.5784 79.0009 39.803 79.0248 40.0167 78.9738C40.2305 78.9229 40.4209 78.8001 40.5567 78.6256L65.7918 46.2371C65.9045 46.0923 65.9747 45.9183 65.9943 45.7351C66.014 45.552 65.9823 45.3669 65.9029 45.201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSupplyActive);
export default __webpack_public_path__ + "static/media/powerSupplyActive.93799a0309d37ddc8fd36b22558588c3.svg";
export { ForwardRef as ReactComponent };